import { clsx } from 'clsx';
export function useLinkProps({
  link: {
    to,
    href,
    target,
    onNavigate,
    id
  },
  className
}) {
  if (href) {
    return {
      className: clsx(className, 'mchNoDecorate'),
      href,
      target,
      onClick: onNavigate,
      id
    };
  }
  if (to) {
    return {
      className: clsx(className, 'mchNoDecorate'),
      onClick: onNavigate,
      to,
      target,
      id
    };
  }
  if (onNavigate) {
    return {
      className: clsx(className, 'mchNoDecorate'),
      onClick: onNavigate,
      id
    };
  }
  return {
    className
  };
}